import { render } from "./CampaignAds.vue?vue&type=template&id=55f92d52&scoped=true"
import script from "./CampaignAds.vue?vue&type=script&lang=js"
export * from "./CampaignAds.vue?vue&type=script&lang=js"

import "./CampaignAds.vue?vue&type=style&index=0&id=55f92d52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f92d52"]])

export default __exports__